import { DateTime } from 'luxon'
import { Courier } from '../../../interfaces/Courier'
import * as Yup from 'yup'

export const initialFormValues: Courier = {
  courierId: 0,
  name: '',
  createdAt: DateTime.now().toJSDate(),
  courierServices: [],
  hasPriorization: false
}

export const courierFormvalidationSchema = Yup.object({
  name: Yup.string().trim().required('Requerido'),
  courierServices: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().trim().required('Requerido')
    })
  )
})
